import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/app/layout/service/layout.service';
import { AuthService } from '@/app/core/services/auth.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, CommonModule, StyleClassModule],
  template: `
    <div class="layout-topbar">
      <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
          <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
          <i class="pi pi-bullseye" style="font-size: 1.75rem; color: var(--primary-color)"></i>
          <span>Sokil CRM</span>
        </a>
      </div>

      <div class="layout-topbar-actions">
        <div class="layout-config-menu">
          <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
            <i
              [ngClass]="{ 'pi': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
          </button>
        </div>

        <button
          class="layout-topbar-menu-button layout-topbar-action"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
          <div class="layout-topbar-menu-content">
            <button type="button" class="layout-topbar-action" routerLink="/profile">
              <i class="pi pi-user"></i>
              <span>{{ displayName() }}</span>
            </button>
            <button type="button" class="layout-topbar-action" (click)="logout()" [disabled]="logoutDisabled()" [title]="logoutDisabled() ? 'Зачекайте...' : ''">
              <i class="pi pi-sign-out"></i>
              <span>Вийти</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class AppTopbar {
  layoutService = inject(LayoutService);
  private authService = inject(AuthService);
  currentUser = this.authService.currentUser;
  logoutDisabled = this.authService.logoutDisabled;
  displayName = computed(() => {
    const user = this.currentUser();
    if (user?.employee?.surname && user?.employee?.name) {
      return `${user.employee.surname} ${user.employee.name}`;
    }
    return user?.employee?.name || user?.email || 'User';
  });

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme
    }));
  }

  logout() {
    this.authService.logout();
  }
}
